import { styled } from "@mui/material";

export const StyledAdditionalContentView = styled("div")(() => ({
  ".box": {
    position: "relative",
    zIndex: 10,
  },
}));
